import ImageGeneratorMain from "./ImageGeneratorMain";

export default ImageGeneratorMain;
